import styled from '@emotion/styled';

export const TabContainer = styled.div`
    display: flex;
    gap: 8px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 24px;
`;

export const Tab = styled.button<{ active: boolean }>`
    padding: 12px 24px;
    background: ${({ active }) => (active ? '#F3F4F6' : 'white')};
    border: ${({ active }) => (active ? '1px solid #6366F1' : '1px solid #E5E7EB')};
    border-bottom: ${({ active }) => (active ? 'none' : '1px solid #E5E7EB')};
    border-radius: 8px 8px 0 0;
    color: ${({ active }) => (active ? '#6366F1' : '#6B7280')};
    font-weight: ${({ active }) => (active ? '600' : '400')};
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
    bottom: -1px;

    &:hover {
        background: #f9fafb;
    }
`;
